import request from "@/utils/request.js"
// 获取产品分类
export function get_type_list(data) {
	return request({
		method: 'GET',
		url: '/aohua.product/get_type_list',
		params: data
	})
}
// 产品分类 - 产品列表
export function get_type_product(data) {
	return request({
		method: 'GET',
		url: '/aohua.product/get_type_product',
		params: data
	})
}

// 产品分类 - 产品列表(除软镜外) - 详情
export function get_product_detail(data) {
	return request({
		method: 'GET',
		url: '/aohua.product/get_product_detail',
		params: data
	})
}

//产品分类 - 产品列表(软镜产品) - 详情
export function get_rj_product_params(data) {
	return request({
		method: 'GET',
		url: '/aohua.product/get_rj_product_params',
		params: data
	})
}
